import ModelFactory from 'business/models/ModelFactory';
import {
  AppDBVersionDTO,
  EmailDTO,
  FileResponse,
  MiscClient,
  ResponseDTO,
  UsageStatClient,
} from 'business/models/Models';
import BaseService from './BaseService';

export default class MiscService extends BaseService {
  async sendTestEmail(): Promise<ResponseDTO> {
    const sendTestEmail: MiscClient = ModelFactory(MiscClient, false, true);
    const root: ResponseDTO = await sendTestEmail.testEmail();
    return root;
  }
  async sendErrorEmail(subject: string, message: string, signal: AbortSignal): Promise<ResponseDTO> {
    const sendErrorEmail: MiscClient = ModelFactory(MiscClient, false, true, signal);
    const emailDTO: EmailDTO = new EmailDTO();
    emailDTO.subject = subject;
    emailDTO.message = message;
    const root: ResponseDTO = await sendErrorEmail.errorEmail(emailDTO);
    return root;
  }
  async sendUsageStatsCSVEmail(timeSpan: number): Promise<ResponseDTO> {
    const sendUsageStatsCSVEmail: MiscClient = ModelFactory(MiscClient, false, true);
    const root: ResponseDTO = await sendUsageStatsCSVEmail.usageStatsCSVEmail(timeSpan);
    return root;
  }

  async getAppDBVersion(): Promise<AppDBVersionDTO> {
    const miscClient: MiscClient = ModelFactory(MiscClient, false, true);
    const root: AppDBVersionDTO = await miscClient.getAppDBVersion();
    return root;
  }

  async downloadLogs(startDate: Date, endDate: Date): Promise<FileResponse> {
    const miscClient: MiscClient = ModelFactory(MiscClient, false, true);
    const root: FileResponse = await miscClient.downloadLogs(startDate.toDateString(), endDate.toDateString());
    return root;
  }

  async sendLabwareReportEmail(receipientEmailAddress: string): Promise<ResponseDTO> {
    const sendTestEmail: UsageStatClient = ModelFactory(UsageStatClient, false, true);
    const root: ResponseDTO = await sendTestEmail.sendLabwareReportEmail(
      receipientEmailAddress,
    );
    return root;
  }
}
